export default "__VITE_ASSET__0LpuRgsX__"